import { computePosition, offset, flip, shift, arrow } from '@floating-ui/dom';

const tooltipInstances = [];

// 他の場所をクリックした時にツールチップを閉じるためのグローバルリスナー
if (typeof document !== 'undefined') {
  document.addEventListener('click', (e) => {
    tooltipInstances.forEach(({ trigger, hide }) => {
      if (!(e.target instanceof Node) || !trigger.contains(e.target)) hide();
    });
  });
}

export function setupTooltips(rootElement = document.body) {
  rootElement.querySelectorAll('[data-tooltip-content]').forEach((trigger) => {
    if (!(trigger instanceof HTMLElement)) return;
    if (trigger.dataset.tooltipInitialized) return;
    trigger.dataset.tooltipInitialized = 'true';

    const content = trigger.dataset.tooltipContent;
    if (!content) return;

    const placement = trigger.dataset.tooltipPlacement || 'top';
    const triggerMode = trigger.dataset.tooltipTrigger || 'both';

    const tooltipId = 'tooltip-' + Math.random().toString(36).slice(2, 9);
    const tooltipEl = document.createElement('div');
    tooltipEl.id = tooltipId;
    tooltipEl.className = 'c-Tooltip_Popup';
    tooltipEl.setAttribute('role', 'tooltip');
    const tooltipText = document.createTextNode(content);
    tooltipEl.appendChild(tooltipText);
    Object.assign(tooltipEl.style, {
      position: 'absolute',
      left: '0',
      top: '0',
      visibility: 'hidden',
      display: 'none',
    });

    const arrowEl = document.createElement('div');
    arrowEl.className = 'c-Tooltip_Arrow';
    tooltipEl.appendChild(arrowEl);
    document.body.appendChild(tooltipEl);

    trigger.setAttribute('aria-describedby', tooltipId);

    const show = () => {
      tooltipText.textContent = trigger.dataset.tooltipContent || content;
      tooltipEl.style.display = 'block';
      computePosition(trigger, tooltipEl, {
        placement,
        middleware: [
          offset(4),
          flip(),
          shift({ padding: 5 }),
          arrow({ element: arrowEl }),
        ],
      }).then(({ x, y, placement: finalPlacement, middlewareData }) => {
        Object.assign(tooltipEl.style, {
          left: x + 'px',
          top: y + 'px',
          visibility: 'visible',
        });

        if (middlewareData.arrow) {
          const { x: ax, y: ay } = middlewareData.arrow;
          const staticSide = {
            top: 'bottom',
            bottom: 'top',
            left: 'right',
            right: 'left',
          }[finalPlacement.split('-')[0]];

          Object.assign(arrowEl.style, {
            left: ax != null ? ax + 'px' : '',
            top: ay != null ? ay + 'px' : '',
            right: '',
            bottom: '',
            [staticSide]: '-6px',
            borderTop: finalPlacement.startsWith('top')
              ? '6px solid rgba(0, 0, 0, 0.9)'
              : 'none',
            borderBottom: finalPlacement.startsWith('bottom')
              ? '6px solid rgba(0, 0, 0, 0.9)'
              : 'none',
          });
        }
      });
    };

    const hide = () => {
      tooltipEl.style.visibility = 'hidden';
      tooltipEl.style.display = 'none';
    };

    if (triggerMode === 'hover' || triggerMode === 'both') {
      trigger.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') show();
      });
      trigger.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') hide();
      });
    }

    if (triggerMode === 'click' || triggerMode === 'both') {
      trigger.addEventListener('click', () => {
        const isHidden =
          tooltipEl.style.display === 'none' ||
          tooltipEl.style.visibility === 'hidden';
        isHidden ? show() : hide();
      });
      tooltipInstances.push({ trigger, hide });
    }
  });
}
